import { heroHighlights } from "@/mocks/nanny";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[680px] lg:min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm-toned%20film%20still%20of%20an%20elegant%20modern%20living%20room%20bathed%20in%20soft%20golden%20afternoon%20light%2C%20sheer%20curtains%20and%20houseplants%2C%20subtle%20dust%20particles%20floating%20in%20the%20air%2C%20moody%20atmospheric%20depth%20and%20shallow%20focus%2C%20muted%20terracotta%20and%20cream%20color%20palette%2C%20art-house%20motion%20picture%20aesthetic%2C%20high%20detail&width=1920&height=1080&seq=nanny-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 md:pt-32 pb-12">
        <div className="w-full max-w-5xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm tracking-wide">
            <i className="ri-film-line"></i>
            电影 · 电视剧 · 短剧 全版本观看入口
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            漂亮的保姆
          </h1>
          <p className="mt-4 text-base md:text-lg text-background-50/90 max-w-3xl mx-auto leading-relaxed">
            一个走进普通家庭的照顾者，一段被日常重新缝合的关系。本站汇集电影、电视剧、短剧等版本信息与观看指引，帮你在几分钟内找到适合自己的那一种打开方式。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#versions"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-play-circle-line text-lg"></i>
              查看版本一览
            </a>
            <a
              href="#synopsis"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-medium px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-book-open-line text-lg"></i>
              先看作品简介
            </a>
          </div>
        </div>

        <div className="w-full max-w-5xl mx-auto mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
          {heroHighlights.map((item) => (
            <a
              key={item.id}
              href="#versions"
              className="text-left bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/20 rounded-lg p-4 md:p-5 cursor-pointer transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-background-50 font-heading text-lg font-semibold">{item.label}</span>
                <i className="ri-arrow-right-up-line text-background-50/70 text-xl"></i>
              </div>
              <p className="mt-1 text-primary-200 text-sm font-medium">{item.value}</p>
              <p className="mt-2 text-background-50/75 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}